import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import photosData from "./WebsiteContent/RecipeContent.json"; // import the JSON

export default function Recipes() {
  const navigate = useNavigate();

  // Map JSON data to resolve the image path
    const photos = photosData.map(photo => ({
    ...photo,
    src: photo.src 
  }));


  return (
    <main>
      <section className="py-5 text-center container">
        <Header />
        <div className="row py-lg-5">
          <div className="col-lg-6 col-md-8 mx-auto">
            <h1 className="fw-light">Recipes</h1>
            <p className="lead text-muted">
             This section shares some of the meals and recipes I love to make. I draw inspiration from my travels and the amazing foods I’ve tasted, my family’s traditions, and the creative cooks and chefs I come across online.
            </p>
          </div>
        </div>
      </section>
      <div className="album py-5 bg-light">
        <div className="container">
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
            {photos.map((photo) => (
              <div className="col" key={photo.id}>
                <div className="card shadow-sm">
                  <img
                    src={photo.src}
                    className="card-img-top"
                    alt={photo.alt}
                    loading="lazy"
                  />
                  <div className="card-body">
                    <p className="card-text">{photo.caption}</p>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="btn-group">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary album-button"
                          onClick={() => navigate(`/photos/recipes/${photo.id}`)}
                        >
                          View
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
}
